import React from 'react';
import { Card } from '../ui/Card';
import { motion } from 'framer-motion';

interface MetricCardProps {
  title: string;
  value: string;
  icon: React.ReactNode;
  trend: string;
  color: 'emerald' | 'blue' | 'purple' | 'orange';
}

export const MetricCard: React.FC<MetricCardProps> = ({ title, value, icon, trend, color }) => {
  const colors = {
    emerald: 'bg-emerald-500',
    blue: 'bg-blue-500',
    purple: 'bg-purple-500',
    orange: 'bg-orange-500',
  };

  return (
    <Card className="p-6 hover:shadow-lg transition-shadow duration-200" hover>
      <motion.div
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        className="flex items-start gap-4"
      >
        <div className={`shrink-0 p-3 rounded-xl ${colors[color]} bg-opacity-10 ring-2 ring-offset-2 ring-${color}-500/30`}>
          {React.cloneElement(icon as React.ReactElement, {
            className: `w-6 h-6 ${colors[color]} text-opacity-90`,
          })}
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="text-sm font-medium text-gray-600 truncate">{title}</h3>
          <p className="mt-1 text-2xl font-bold text-gray-900">{value}</p>
          <p className="mt-1 text-xs font-medium text-gray-500">{trend}</p>
        </div>
      </motion.div>
    </Card>
  );
};